var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectSidebarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.397,
    height: 15,
    viewBox: "0 0 18.397 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project_icon",
    "data-name": "Project icon",
    transform: "translate(-457.87 -532.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M467.14,547.08a.777.777,0,0,1-.02-.16l.34-1.95a1.289,1.289,0,0,1,.27-.58l.38-.45,1.25-1.46,3.51-4.14v-2.65a3,3,0,0,0-3-3h-9a3,3,0,0,0-3,3v9a3,3,0,0,0,3,3h7.02A.753.753,0,0,1,467.14,547.08Zm-5.52-10.64h7.5a.749.749,0,0,1,.75.75.713.713,0,0,1-.16.46.344.344,0,0,1-.08.09.754.754,0,0,1-.51.2h-7.5a.754.754,0,0,1-.51-.2.344.344,0,0,1-.08-.09.713.713,0,0,1-.16-.46A.749.749,0,0,1,461.62,536.44Zm3.75,7.5h-3.75a.743.743,0,0,1-.75-.75.522.522,0,0,1,.04-.21.7.7,0,0,1,.47-.5.673.673,0,0,1,.24-.04h3.75a.75.75,0,0,1,0,1.5Zm-3.75-3a.743.743,0,0,1-.75-.75.7.7,0,0,1,.18-.48.742.742,0,0,1,.57-.27h5.065a.523.523,0,0,1,.21.04.734.734,0,0,1,.53.58.57.57,0,0,1,.01.13.681.681,0,0,1-.18.48.711.711,0,0,1-.57.27Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M469.89,547.04l-1.83.64a.969.969,0,0,1-.17.01h1.98a3,3,0,0,0,3-3v-.89l-2.45,2.88A1.285,1.285,0,0,1,469.89,547.04Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M476.16,538.67l-1.46-1.24a.306.306,0,0,0-.2-.07.315.315,0,0,0-.23.11l-1.4,1.65-4.76,5.6a.681.681,0,0,0-.16.33l-.33,1.92a.261.261,0,0,0,.31.22l1.8-.63a.715.715,0,0,0,.31-.21l2.83-3.33,3.33-3.92A.313.313,0,0,0,476.16,538.67Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSidebarImage);
export default __webpack_public_path__ + "static/media/Project-sidebar-image.b4ad4e84aad56942d843217d380a0e3d.svg";
export { ForwardRef as ReactComponent };